import { render } from "./HeroiconsSolidSaveAs.vue?vue&type=template&id=0d73f552"
const script = {}

import exportComponent from "/Users/dorinpuscasu/Desktop/Projects/linella/linella-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidSaveAs.vue"]])

export default __exports__